export enum SearchType {
    Normal = 0,
    Formulation = 1,
    Mcs2 = 2,
    Mcs3 = 3
}
